"use strict";

exports.__esModule = true;
exports.default = property;
var _deepGet = _interopRequireDefault(require("./_deepGet.js"));
var _toPath = _interopRequireDefault(require("./_toPath.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Creates a function that, when passed an object, will traverse that object’s
// properties down the given `path`, specified as an array of keys or indices.
function property(path) {
  path = (0, _toPath.default)(path);
  return function (obj) {
    return (0, _deepGet.default)(obj, path);
  };
}